




























import Vue, { PropType } from "vue";
import axios from "axios";
import { passwordConstraintMessage } from "@/views/forms/constraint";
import VariableInput from "@/components/util/VariableInput.vue";
import { deleteUser, deleteCorporateUser, getUserProfile } from "@/api/UserProfile";
import { deleteCorporate } from "@/api/Corporation";
import { login } from "@/api/Login";
import { ErrorResponse } from "@/api/dto/Error";

/**
 * サーバー側のエラーが判定する
 */
const isErrorResponse = (e: unknown): e is ErrorResponse => {
  return (e as Object).hasOwnProperty("message") && (e as Object).hasOwnProperty("code");
};

export default Vue.extend({
  name: "DeleteAccountConfirmModal",
  components: {
    VariableInput,
  },
  props: {
    // v-model で渡される
    value: Boolean,
    mode: String,
  },
  data() {
    return {
      isApiProcessing: false,
      accountData: {
        password: "",
      },
      input: {
        name: "パスワード",
        type: "password",
        constraint: passwordConstraintMessage,
        placeholder: "パスワード",
        error: "",
      },
    };
  },
  methods: {
    /**
     * パスワードが正しいかチェックする
     * ログインできた場合は正しい
     */
    async validatePassword(): Promise<boolean> {
      // NOTE: Vuex storeにメールアドレスが保持されていないので取得する必要がある
      const res = await getUserProfile();

      if (!res.userId) {
        return false;
      }

      // NOTE: DELETE methodにリクエストボディを渡せないので, ログインできるかチェックすることで確認する
      if (res.userCategory == '3') {
        return this.$store
          .dispatch("login", {
            corporateId: res.corporationsData.corporateId,
            mailAddress: res.mailAddress,
            password: this.accountData.password,
          })
          .then(() => true)
          .catch(() => false);
      } else {
        return this.$store
          .dispatch("login", {
            mailAddress: res.mailAddress,
            password: this.accountData.password,
          })
          .then(() => true)
          .catch(() => false);
      }
    },
    /**
     * アカウント削除を行う
     */
    async deleteAccount() {
      const res = await getUserProfile();

      try {
        this.isApiProcessing = true;
        // パスワードチェック
        if (!(await this.validatePassword())) {
          const message = "パスワードが正しくありません";
          this.$emit("errorToast", message);
          return;
        }
        // ユーザーデータを削除
        if (res.userCategory == '3') {
          await deleteCorporateUser().catch((e: ErrorResponse) => {
            this.$emit("errorToast", `[${e.code}] ${e.message}`);
            throw e;
          });
        } else {
          await deleteUser().catch((e: ErrorResponse) => {
            this.$emit("errorToast", `[${e.code}] ${e.message}`);
            throw e;
          });
        }

        // ログアウト
        await this.$store.dispatch("logout");
        // モーダルを閉じる
        this.$emit("input", false);
        // トップページに遷移
        this.$router.push({ name: "Top" });
        this.$emit("toast", 'アカウント退会処理が完了しました');
      } catch (e) {
        console.error(e);
      } finally {
        this.isApiProcessing = false;
      }
    },
    /**
     * 法人削除を行う
     */
    async deleteCorporate() {
      const res = await getUserProfile();

      try {
        this.isApiProcessing = true;
        // パスワードチェック
        if (!(await this.validatePassword())) {
          const message = "パスワードが正しくありません";
          this.$emit("errorToast", message);
          return;
        }
        // 法人データを削除
        await deleteCorporate()

        // ログアウト
        await this.$store.dispatch("logout");
        // モーダルを閉じる
        this.$emit("input", false);
        // トップページに遷移
        this.$router.push({ name: "Top" });
        this.$emit("toast", '法人退会処理が完了しました');
      } catch (e) {
        if (axios.isAxiosError(e)) {
          const res = (e.response?.data as ErrorResponse);
          this.$emit('errorToast', res.message);
          return; 
        }
      } finally {
        this.isApiProcessing = false;
      }
    },
  },
});
